import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-widgets',
  template: `
    <p>
      widgets works!
    </p>
  `,
  styles: []
})
export class WidgetsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
